import { get } from '../utils/networking';
import { SSOAvailabilityResponse } from './types/sso.types';

export async function checkSSOAvailability(
  email: string
): Promise<SSOAvailabilityResponse> {
  return get<SSOAvailabilityResponse>(
    `/api/auth/sso/check?email=${encodeURIComponent(email)}`
  );
}
